import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';
import { ColourPaletteType, SizeType } from '@dxp/core/models';

@Component({
    selector: 'telxl-button',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './button.component.html',
    styleUrls: [
        './button.component.primary.scss',
        './button.component.secondary.scss',
        './button.component.success.scss',
        './button.component.warning.scss',
        './button.component.info.scss',
        './button.component.light.scss',
        './button.component.danger.scss',
        './button.component.dark.scss',
        './button.component.dropdown.scss',
        './button.component.transparent.scss',
        './button.component.pill.scss',
        './button.component.notes.scss',
        './button.component.ai.scss',
    ],
})
export class TelXLButtonComponent {
    @Input() active = false;
    @Input() label = '';
    @Input() aria: string | null = null;
    @Input() className: string | null = null;
    @Input({ required: true }) colour!: ColourPaletteType;
    @Input() disabled = false;
    @Input() outline = false;
    @Input() size: SizeType | null = null;
    @Input() type: 'button' | 'submit' | 'reset' = 'button';
    @Output() buttonClick = new EventEmitter<Event>();

    get buttonClass(): string {
        const classes = ['w-100', 'h-100', 'btn'];

        const variant = this.outline
            ? `btn-outline-${this.colour}`
            : `btn-${this.colour}`;
        classes.push(variant);

        if (this.size) {
            classes.push(`btn-${this.size}`);
        }

        return classes.join(' ');
    }

    get combinedClass(): string[] {
        return [this.buttonClass, this.className].filter(Boolean) as string[];
    }

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.buttonClick.emit(event);
    }
}
